import React, { Component } from "react"
import { observer } from "mobx-react"
import { withRouter, Link } from "react-router-dom"

import { Button, Modal } from "semantic-ui-react"
import shop from "shop/shop"


let store = shop.store.orderlist
let orderlist = shop.orderlist

@withRouter
@observer
export default class OrderlistSelection extends Component {

  addToList = name => {
    let list = orderlist.lists[ name ]
    let product = store.currentProduct

    if ( list && product ) {
      //store.setCurrentList( list )
      list.add( store.currentProduct )
      list.save(  )
      store.toggleSelectionModal()
      shop.toast( `Produkt hinzugefügt`, "info", false, "bottom" )
    }
  }

  render() {
    return <div>
      {console.log("listnames", shop.orderlist)}
      <Modal open={store.isOpenSelectionModel} onClose={store.toggleSelectionModal} size="small">
      <Modal.Header showCloseButton onClose={store.toggleSelectionModal}>
        {translate("Merkliste auswählen")}
      </Modal.Header>
      <Modal.Content>
        {shop.orderlist.listnames
        .filter(name => name !== "Merkliste")
        .map(name => (
          <div key={`to-list-${name}`} className="mb2">
          <Button
            fluid
            primary
            onClick={() => {
            this.addToList(name);
            }}
          >
            {shop.orderlist && shop.orderlist.lists[name] && shop.orderlist.lists[name].customName || name}
          </Button>
          </div>
        ))}
      </Modal.Content>
      <Modal.Actions>
        <div className=" ">
        <Button basic onClick={store.toggleSelectionModal}>{translate("Zurück")}</Button>
        <Button
          onClick={() => {
          this.props.history.push("/orderlist");
          store.toggleSelectionModal();
          }}
          type="link-cancel"
        >
          {translate("Merklisten verwalten")}
        </Button>
        </div>
      </Modal.Actions>
      </Modal>
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/Orderlist/OrderlistSelection.js